var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('my-view',{attrs:{"PageOrderPay":_vm.PageOrderPay,"GetOrderPayState":_vm.GetOrderPayState,"PtPageOrderPay":_vm.PtPageOrderPay,"SinglePageOrderPay":_vm.SinglePageOrderPay}})}
var staticRenderFns = []

export { render, staticRenderFns }